import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

const TOKEN_KEY = "talleros_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export const BRANCH_KEY = "talleros_active_branch_id";
export const OPERATIVE_ROLES = ["tecnico", "mecanico", "hojalatero"];
export const isOperative = (user) => OPERATIVE_ROLES.includes(user?.role_name);
export const homePathFor = (user) => (isOperative(user) ? "/mis-trabajos" : "/dashboard");
const OPERATIVE_PATHS = ["/mis-trabajos", "/cambiar-contrasena"];
export const operativeCanVisit = (path) => OPERATIVE_PATHS.some((p) => path === p || path.startsWith(`${p}/`));
const BRANCH_NAME_KEY = "talleros_active_branch_name";

// Keeps the stored active branch within the user's authorized branches.
export function syncActiveBranch(branches, primaryId) {
  const list = branches || [];
  const stored = localStorage.getItem(BRANCH_KEY);
  const pick = list.find((b) => b.id === stored) || list.find((b) => b.id === primaryId) || list.find((b) => b.is_main) || list[0];
  if (pick) {
    localStorage.setItem(BRANCH_KEY, pick.id);
    localStorage.setItem(BRANCH_NAME_KEY, pick.name || pick.code || "");
  } else {
    localStorage.removeItem(BRANCH_KEY);
    localStorage.removeItem(BRANCH_NAME_KEY);
  }
  return pick?.id || null;
}

export function getActiveBranchName() {
  return localStorage.getItem(BRANCH_NAME_KEY) || "Sucursal activa";
}

api.interceptors.request.use((config) => {
  const token = getToken();
  config.headers = config.headers || {};
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const branchId = localStorage.getItem(BRANCH_KEY);
  if (branchId && !config.headers["X-Branch-Id"]) config.headers["X-Branch-Id"] = branchId;
  return config;
});

const SESSION_ERRORS = {
  tenant_suspended: "La cuenta del taller está suspendida. Contacta a VRIntegrales.",
  password_change_required: "Debes cambiar tu contraseña para continuar.",
};

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail;
    const url = err?.config?.url || "";
    if (status === 403 && detail === "password_change_required" && window.location.pathname !== "/cambiar-contrasena") {
      window.location.assign("/cambiar-contrasena");
    } else if (status === 403 && detail === "tenant_suspended") {
      setToken(null);
      window.sessionStorage.setItem("talleros_logout_reason", SESSION_ERRORS.tenant_suspended);
      if (window.location.pathname !== "/login") window.location.assign("/login");
    } else if (status === 401 && getToken() && !url.includes("/auth/login") && !url.includes("/auth/change-password")) {
      setToken(null);
      if (window.location.pathname !== "/login") window.location.assign("/login");
    }
    if (typeof detail === "string" && SESSION_ERRORS[detail]) err.response.data.detail = SESSION_ERRORS[detail];
    return Promise.reject(err);
  }
);

export async function fetchFileBlobUrl(path) {
  try {
    const { data } = await api.get(path, { responseType: "blob" });
    return URL.createObjectURL(data);
  } catch (err) {
    const blob = err?.response?.data;
    if (blob instanceof Blob) {
      try { err.response.data = JSON.parse(await blob.text()); } catch { /* keep original */ }
    }
    throw err;
  }
}

export async function openAuthorizedFile(path, filename) {
  const url = await fetchFileBlobUrl(path);
  if (filename) {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
  } else {
    window.open(url, "_blank", "noopener");
  }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Ocurrió un error inesperado";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" · ");
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}
